import fecha from 'fecha';

export function formatDate(timestamp) {
  try {
    return fecha.format(Date.parse(timestamp), 'D MMM YYYY');
  } catch (e) {
    return '';
  }
}
